<template>
  <div>
    <h2 class="modal-title">Интеграция CRMCalls CC</h2>
    <div class="modal-subtitle">Название интеграции</div>
    <v-text-field
      v-model="form.name"
      placeholder="Например: Основной CRMCalls CC"
      maxlength="150"
      outlined
      dense
      @input="emitData"
    />
    <div class="modal-subtitle">API-токен CRMCalls CC</div>
    <v-text-field
      v-model="form.api_token"
      type="text"
      autocomplete="off"
      placeholder="Вставьте токен из CRMCalls CC"
      outlined
      dense
      @input="emitData"
    />
  </div>
</template>

<script>
export default {
  props: ['update', 'pre_data'],
  data() {
    return { form: { name: '', api_token: '' } };
  },
  mounted() {
    this.form.name = (this.pre_data && this.pre_data.name) || '';
    this.form.api_token = (this.pre_data && this.pre_data.api_token) || '';
    this.emitData();
  },
  methods: {
    emitData() {
      this.update({ name: this.form.name, api_token: this.form.api_token });
    },
  },
};
</script>

<style scoped>
.modal-title { margin-bottom: 24px; color: #2b2d33; font-size: 24px; text-align: center; }
.modal-subtitle { margin-bottom: 6px; color: #404247; font-size: 15px; font-weight: 600; text-align: left; }
</style>
